import { cn } from '@/lib/utils';

/**
 * Consistent top-of-page heading. Every primary page mounts one of these
 * so the visual rhythm matches across the app: 20px icon (optional) + h1
 * + muted subtitle, and any actions docked to the right edge.
 */
export function PageHeader({
  icon,
  title,
  subtitle,
  meta,
  actions,
  className,
}: {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  /** Small inline meta — count chip, badge, etc. */
  meta?: React.ReactNode;
  /** Right-side actions (button cluster, filters etc). */
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-4 pb-2', className)}>
      <div className="flex items-start gap-3">
        {icon ? (
          <div className="grid h-9 w-9 place-items-center rounded-lg bg-primary/10 text-primary">
            {icon}
          </div>
        ) : null}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h1 className="page-title">{title}</h1>
            {meta}
          </div>
          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
